import React from "react";
import "../css/privacy-policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-section">
      <div className="privacy-policy-content">
        <h2>Privacy Policy</h2>
        <div className="privacy-policy-introduction">
          <h2>INTRODUCTION</h2>
          <p>
          Vanasthali Jungle Resort Jim Corbett, Ramnagar offers air-conditioned rooms with modern amenities, free WiFi, and a restaurant. Located 1.5 km from the main road amidst the jungle, it’s near a seasonal river and 46 km from Pantnagar Airport. Guests can enjoy cycling, a playground, and a continental breakfast.
          </p>
          <br />
          <p>
            If you are accessing any of the Sites from outside India means, you
            agree that your personal information may be transferred to India, a
            jurisdiction which may have different privacy and data security
            protections than from those of your own jurisdiction, to be
            processed and stored.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>COLLECTION OF PERSONAL INFORMATION</h2>
          <p>
            Personal information is data that can be used to uniquely identify
            or contact a single person. Vanasthali Jungle Resort collect several types of personal information from and about
            users of the Sites, including, but not limited to:
          </p>
          <br />
          <p>
            Personal information that is provided to us by travel agencies or
            online travel sites.
          </p>
          <br />
          <p>Personal information you provide to us directly on the Site;</p>
          <br />
          <p>
            Personal information included in any messaging you undertake through
            any of the Sites, such as sharing via our online blog or using one
            of our travel management tools or apps;
          </p>
          <br />
          <p>
            Please note that this privacy statement does not apply to the
            collection of routine business contact information by our employees.
            Such information, however, will only be used for purposes of our
            business relationship.
          </p>
          <br />
          <p>
            Vanasthali Jungle Resort shall not sell, trade or
            disclose to any third party other than an entity in the "Royal
            Collection Hotels & Resorts Pvt. Ltd. Group" any information derived
            from the registration for, or use of, any on-line service without
            the consent of the user (except as required by law or in the case of
            imminent physical harm to the user or others). When Royal Collection
            Hotels & Resorts Pvt. Ltd. uses other agents, contractors or
            corporations to perform services on its behalf or as part of a joint
            promotion, Vanasthali Jungle Resort shall ensure
            that this entity protects the user's personal information in a
            manner which is consistent with this statement. If you choose not to
            provide certain personal information we request, you will be able to
            visit our web site but you may be unable to access certain options
            or services.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>USE OF PERSONAL INFORMATION</h2>
          <br />
          <h3>We use personal information in the following ways:</h3>
          <p>
            To provide you such information, products or services that you
            requested from Vanasthali Jungle Resort;
          </p>
          <br />
          <p>
            To present the Site(s) and their contents in a suitable and
            effective manner;
          </p>
          <br />
          <p>
            To allow you the sharing and messaging features of the Sites, if and
            when you choose to do so.
          </p>
          <br />
          <p>
            Registered users will occasionally receive information on products,
            services and special deals offered by Royal Collection Hotels &
            Resorts Pvt. Ltd.
          </p>
          <br />
          <p>
            From time-to-time contests may be conducted via our web site.
            Participation in these contests is completely voluntary and the user
            therefore has a choice whether or not to disclose any personal
            information in connection with such contest them. Information
            requested may include contact information (such as name and mailing
            address), and demographic information (such as age). Contact
            information will be used to notify the winner(s) and award prize(s).
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>DISCLOSURE OF PERSONAL INFORMATION TO THIRD PARTIES</h2>
          <h3>
            We may from time-to-time make certain personal information available
            to strategic partners associated with the Company, such as the
            following:
          </h3>
          <p>Various affiliates of the Company;</p>
          <br />
          <p>
            Travel supply companies through which you have arranged travel, but
            only that personal information needed for successful access to or
            processing of your travel arrangements;
          </p>
          <br />
          <p>
            Service provider(s) we use to support our business who provide
            services such as information processing, managing and enhancing
            customer data, providing customer service, assessing your interest
            in our products and services, and conducting customer research or
            satisfaction surveys;
          </p>
          <br />
          <p>
            In the event of merger, acquisition, or any form of sale of some or
            all of the Company’s assets, in such case personal information held
            by the Company about its customers will be considered among the
            assets to be transferred to the buyer.
          </p>
          <br />
          <p>
            In case, Vanasthali Jungle Resort engage a third
            party to process an individual’s personal data on its behalf, that
            third party will be bound by our data privacy policies.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>
            WE MAY ALSO DISCLOSE YOUR PERSONAL INFORMATION TO THIRD PARTIES:
          </h2>
          <p>
            To comply with any court order or other legal obligation or on
            request by the government or by any law enforcement authority;
          </p>
          <br />
          <p>
            To enforce or apply our terms of use and any other agreements; or
          </p>
          <br />
          <p>
            To protect the rights, property, or safety of the Company, our
            customers, or others. This may include exchanging information with
            other companies and organizations for the purposes of fraud
            protection and credit risk reduction.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>COLLECTION AND USE OF NON-PERSONAL INFORMATION</h2>
          <p>
            Vanasthali Jungle Resort also collect
            non-personal information, or data in a form that cannot be used to
            uniquely identify or contact a single person. We may collect, use,
            transfer, and disclose non-personal information for any purposes.
            Non-personal information that we collect may include information
            regarding your activities on any of the Sites, which may be
            aggregated and used to help us provide more useful information to
            our customers and to understand which parts of the Sites are of most
            interest. If we combine non-personal information with personal
            information in that cast the combined information will be treated as
            personal information for the purposes of this privacy statement.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>COOKIES AND OTHER TECHNOLOGIES</h2>
          <p>
            The Sites and certain Company email messages may use “cookies” and
            other technologies such as pixel tags and web beacons. These
            technologies help us to improve and to deliver the better and more
            personalized service(s) to:
          </p>
          <br />
          <ul>
            <li>Estimate our audience size and usage patterns</li>
            <li>
              Store information about your preferences, allowing us to better
              customize the Sites according to your individual interests
            </li>
            <li>Speed up your searches</li>
            <li>Recognize you when you return to any of the Sites.</li>
          </ul>
          <br />
          <p>
            You may refuse to accept cookies by activating the appropriate
            settings on your browser. Check with your provider to find out how
            to disable cookies. Please note that certain features of the Sites
            may not be available if cookies are disabled. Royal Collection
            Hotels & Resorts Pvt. Ltd. treat information collected by cookies
            and other technologies as non-personal information. However, to the
            extent that Internet Protocol (IP) addresses or similar identifiers
            are considered personal information by local law, we treat these
            identifiers as personal information. Similarly, to the extent that
            non-personal information is combined with personal information, we
            treat the combined information as personal information for the
            purposes of this privacy statement.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>ACCESSING YOUR PERSONAL INFORMATION</h2>
          <p>
            Vanasthali Jungle Resort strive to maintain
            accurate, complete, and relevant personal information for the
            purposes identified in this privacy statement. We make good faith
            efforts to make available for your review of personal information
            and to process requests for modification of inaccurate personal
            information provided to us through any of the Sites. However, we may
            decline to process requests that are unreasonably repetitive,
            require disproportionate technical effort, jeopardize the privacy of
            others, and are extremely impractical, or for which access is not
            otherwise required by local law. Personal information that is
            provided considered likely to be available for review through the
            organization that made the booking and pursuant to that
            organization’s policies.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>DATA SECURITY</h2>
          <p>
            Vanasthali Jungle Resort has implemented
            reasonable well designed measures to secure your personal
            information from accidental loss and from unauthorized access, use,
            alteration and disclosure. The safety and security of your
            information shall also depend on you. Any content, including
            personal information, that you contribute to be shared, published or
            displayed on any of the Sites, or transmitted to other users of a
            Site, is visible to other users and can be read, collected, or used
            by them. We urge you to be extra careful & cautious on providing
            information in public areas of any of the Sites. Moreover, we
            believe that you understand and acknowledge that, even after
            removal, copies of your content, including personal information,
            that you contribute to be shared, published or displayed on a Site,
            or transmitted to other users of a Site, may remain viewable in
            cached and archived pages. Although we take efforts to protect your
            personal information, in spite of this we cannot guarantee the
            security of your personal information transmitted to a Site. Any
            transmission of personal information is at your own risk & peril.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>CHILDREN UNDER THE AGE OF 18 YRS.</h2>
          <p>
            We do not knowingly collect any personal information from the young
            adult below the age 18yrs. The moment we become aware to have
            collected personal information from the young adjust below the age
            18yrs. without verification of parental consent, we will take steps
            to delete that personal information as soon as possible.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>CHANGES TO OUR PRIVACY STATEMENT</h2>
          <p>
            It is our policy to post any changes we make to our privacy
            practices on this page. The date the privacy statement was last
            revised is identified at the top of the privacy statement.
          </p>
        </div>
        <div className="privacy-policy-introduction">
          <h2>CONTACT INFORMATION</h2>
          <p>
            Please direct any questions or comments about this privacy statement
            and our privacy practices to us Village Gorakhpur Moti Post. Chhoi Jim Corbet National Park, Ramnagar, 244715, India
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
